import styled from 'styled-components';
import { Colors } from '../../constants/colors';
import { Fonts } from '../../constants/fonts';
import { Device } from '../../constants/device';

type ButtonProps = {
  compact?: boolean;
}

export const Button = styled.button<ButtonProps>`
  border: none;
  background: ${Colors.primary};
  color: ${Colors.white};
  font-family: ${Fonts.base};
  font-size: 16px;
  font-weight: ${props => props.compact ? 500 : 600};
  line-height: ${props => props.compact ? '40px' : '50px'};
  padding: 0 ${props => props.compact ? '25px' : '50px'};
  border-radius: 6px;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  :hover:not([disabled]) {
    background: ${Colors.primaryDarker};
  }

  &[disabled] {
    background: ${Colors.grey};
  }

  ${Device.downTablet} {
    line-height: 1.2;
    padding: 10px 15px;
  }

  > svg {
    margin-left: 10px;
    position: relative;
    bottom: 1px;
  }
`;

Button.defaultProps = {
  compact: false
};

